var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper-qrcode-form" }, [
    _c("section", [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("section-title", {
              attrs: {
                title: _vm.$t("apps.pos.label.customer"),
                fontweight: "bold"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row row-input" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("apps.pos.message.qrcodeappprovider")))
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.myForm.appProvider,
                  expression: "myForm.appProvider"
                }
              ],
              staticClass: "custom-select form-control",
              attrs: { disabled: _vm.isSubmitted || _vm.disabled },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.myForm,
                    "appProvider",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { value: "web" } }, [
                _vm._v(
                  _vm._s(_vm.$t("apps.pos.message.defaultqrcodeappproviderweb"))
                )
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "line" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("apps.pos.message.defaultqrcodeappproviderline")
                  )
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("apps.pos.message.qrcodetype")))]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.myForm.qrcodeType,
                  expression: "myForm.qrcodeType"
                }
              ],
              staticClass: "custom-select form-control",
              attrs: { disabled: _vm.isSubmitted || _vm.disabled },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.myForm,
                    "qrcodeType",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { value: "one_time_use" } }, [
                _vm._v(_vm._s(_vm.$t("apps.pos.message.qrcodetypeonetimeuse")))
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "reusable" } }, [
                _vm._v(_vm._s(_vm.$t("apps.pos.message.qrcodetypereusable")))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("apps.pos.message.qrcoderequestapproveacess")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "vs-checkbox",
                {
                  staticStyle: {
                    float: "left",
                    position: "relative",
                    top: "1px",
                    left: "-5px"
                  },
                  attrs: {
                    disabled: _vm.isSubmitted || _vm.disabled,
                    color: "#A3CA76"
                  },
                  model: {
                    value: _vm.myForm.isClientApproveAccessRequired,
                    callback: function($$v) {
                      _vm.$set(_vm.myForm, "isClientApproveAccessRequired", $$v)
                    },
                    expression: "myForm.isClientApproveAccessRequired"
                  }
                },
                [
                  !_vm.myForm.isClientApproveAccessRequired
                    ? _c("span", [_vm._v(_vm._s(_vm.$t("message.no")))])
                    : _c("span", [_vm._v(_vm._s(_vm.$t("message.yes")))])
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("apps.pos.message.qrcoderequestapproveorder")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "vs-checkbox",
                {
                  staticStyle: {
                    float: "left",
                    position: "relative",
                    top: "1px",
                    left: "-5px"
                  },
                  attrs: {
                    disabled: _vm.isSubmitted || _vm.disabled,
                    color: "#A3CA76"
                  },
                  model: {
                    value: _vm.myForm.isClientApproveOrderRequired,
                    callback: function($$v) {
                      _vm.$set(_vm.myForm, "isClientApproveOrderRequired", $$v)
                    },
                    expression: "myForm.isClientApproveOrderRequired"
                  }
                },
                [
                  !_vm.myForm.isClientApproveOrderRequired
                    ? _c("span", [_vm._v(_vm._s(_vm.$t("message.no")))])
                    : _c("span", [_vm._v(_vm._s(_vm.$t("message.yes")))])
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.isShowExpire
          ? _c("div", { staticClass: "col-12" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("apps.pos.message.qrcodeexpiretime")))
              ]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.myForm.expireTime,
                      expression: "myForm.expireTime"
                    }
                  ],
                  staticClass: "form-control number-only text-select-all",
                  attrs: {
                    disabled: _vm.isSubmitted || _vm.disabled,
                    type: "text"
                  },
                  domProps: { value: _vm.myForm.expireTime },
                  on: {
                    keypress: _vm.numberOnly,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.myForm, "expireTime", $event.target.value)
                    }
                  }
                })
              ])
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "mt-4" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("section-title", {
              attrs: {
                title: _vm.$t("apps.pos.label.restaurant"),
                fontweight: "bold"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row row-input" }, [
        _vm.isShowBranch
          ? _c("div", { staticClass: "col-12" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("apps.pos.label.branch")))]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.myForm.branchId,
                      expression: "myForm.branchId"
                    }
                  ],
                  staticClass: "custom-select form-control",
                  attrs: { disabled: _vm.isSubmitted || _vm.disabled },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.myForm,
                        "branchId",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.branches, function(branchItem, branchIndex) {
                  return _c(
                    "option",
                    {
                      key: branchIndex,
                      domProps: { value: branchItem.branchId }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(branchItem.name) +
                          "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowPosSession
          ? _c("div", { staticClass: "col-12" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("apps.pos.label.possession")))
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.myForm.psId,
                      expression: "myForm.psId"
                    }
                  ],
                  class: [
                    "custom-select form-control",
                    {
                      "is-invalid": _vm.isInvalidPosSession
                    }
                  ],
                  attrs: { disabled: _vm.isSubmitted || _vm.disabled },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.myForm,
                        "psId",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.posSessions, function(psItem, psIndex) {
                  return _c(
                    "option",
                    { key: psIndex, domProps: { value: psItem.ps_id } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(psItem.ps_code) +
                          "\n          "
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.isInvalidPosSession
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "apps.pos.message.pleaseopensalebeforecreateqrcode"
                          )
                        ) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("label", [_vm._v(_vm._s(_vm.refName))]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.myForm.table,
                  expression: "myForm.table"
                }
              ],
              staticClass: "custom-select form-control",
              class: [{ "is-invalid": !_vm.myForm.table }],
              attrs: { disabled: _vm.isSubmitted || _vm.disabled },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.myForm,
                    "table",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("placeholder.select")) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.tableLists, function(item, index) {
                return _c(
                  "option",
                  { key: index, domProps: { value: item.name } },
                  [
                    _vm._v(
                      "\n            " + _vm._s(item.name) + "\n          "
                    )
                  ]
                )
              })
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3493e972", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3493e972","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/QRCodeForm.vue
// module id = null
// module chunks = 